import { getStateStore, isObjEmpty, getParamQueryTheme } from '@/utils/utils';
import axiosLib from 'axios';

const axiosAuth2 = axiosLib.create();

axiosAuth2.interceptors.request.use((request) => {
    const stateStore = getStateStore();
    const token = stateStore.tokenV3 || '';
    const setting = stateStore.configDevice;
    const code = getParamQueryTheme('code') || '';

    if (token) {
        // request.headers.Authorization = token;
        request.headers.ContentType = 'application/json';
    }
    request.headers['lang'] = stateStore.lang || 'fr';
    request.headers['retail-account'] = code;

    if (!isObjEmpty(setting)) {
        if (!setting.position) setting.position = {}
        setting.position.error_message = setting.location_error
        request.headers['Device-Network-Mac-Address'] = setting.mac;
        request.headers['Device-Serial-Number'] = setting.serial;
        request.headers['Device-Unique-Id'] = setting.uniqueId;
        request.headers['App-Version'] = setting.appVersion;
        request.headers['Device-Position'] = JSON.stringify(setting.position)
        //console.log(`request.headers['Device-Position']: ` + request.headers['Device-Position'])
    }

    return request;
});

axiosAuth2.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
            return Promise.reject('ECONNABORTED');
        }

        if (error.response && error.response.data) {
            return Promise.reject(error.response.data);
        }
        return Promise.reject(error.message);
    },
);

export default axiosAuth2;
